import { jsx as _jsx } from "react/jsx-runtime";
import { getPrimaryMemberCard } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Suspense } from 'react';
import { useMemberContext } from '../../../context/member/hooks/use-member-context';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { Barcode, BarcodeType } from '../../../subcomponents/barcode';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { defaultMemberBarcodeProps, memberBarcodePropsValidator } from './types/props';
const b = bemClassBuilder('v-member-barcode');
export const MemberBarcode = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { config } = props;
    const { member } = useMemberContext();
    const loadingIndicator = enableSkeletonLoadingIndicators ? _jsx(MemberBarcodeSkeleton, {}) : null;
    if (!member)
        return loadingIndicator;
    const primaryCard = getPrimaryMemberCard();
    if (!primaryCard)
        return null;
    const oneDimensional = config.type === BarcodeType.Code128;
    return (_jsx(Suspense, Object.assign({ fallback: loadingIndicator }, { children: _jsx("div", Object.assign({ className: b.block({ oneDimensional }) }, { children: _jsx(Barcode, { showLabel: false, value: primaryCard.cardNumber, type: config.type }) })) })));
});
MemberBarcode.displayName = 'MemberBarcode';
export const MemberBarcodeSkeleton = () => _jsx("div", { className: b.block({ skeleton: true }) });
MemberBarcodeSkeleton.displayName = 'MemberBarcodeSkeleton';
/**
 * The **Member Barcode** component renders the currently logged-in Loyalty member barcode.
 *
 * If the currently logged-in member does not have a primary card, the **Member Barcode** component will not render.
 */
export const MemberBarcodeComponent = withComponentWrapper(MemberBarcode, defaultMemberBarcodeProps, memberBarcodePropsValidator);
